<template>
  <div class="w-auto custom-tooltip" >
    <i class="fas fa-info-circle tooltip-icon"></i>
    <span class="tooltip-text"><slot /></span>
  </div>
</template>

<script>
export default {
  name: "Tooltip"
};
</script>

<style lang="scss" scoped>
.custom-tooltip {
  position: relative;

  .tooltip-icon {
    cursor: pointer;

    &:hover ~ .tooltip-text {
      display: block;
    }
  }

  .tooltip-text {
    font-family: "Roboto", sans-serif;

    display: none;
    width: max-content;
    max-width: 300px;
    background-color: rgba(16, 16, 16, 0.8);
    color: #fff;
    text-align: justify;
    border-radius: 6px;
    padding: 0.5rem 1rem;

    position: absolute;
    left: 15px;
    bottom: 50%;
    transform: translateY(50%);
    z-index: 1;
    left: 20px;

    transition: opacity 0.2s;

    &::before {
      content: "";
      display: block;
      width: 0;
      height: 0;
      position: absolute;

      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      border-right: 5px solid rgba(16, 16, 16, 0.8);

      left: -5px;
      bottom: 50%;
      transform: translateY(50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tooltip.vue